import { Link, useRouteError } from "react-router-dom";
import { PAGE_PERMISSIONS } from "./Constants";

const ErrorPage = () => {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>
        Sorry, an unexpected error has occurred. Click{" "}
        <Link to="/dashboard">here</Link> to return.
      </p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
};

export default ErrorPage;
export const MENUS_PERMISSION_MAP = [
  {
    item: "Dashboard Menu",
    pathname: "/dashboard",
    permission: PAGE_PERMISSIONS.PERM_DASHBOARD_MENU,
    subMenus: [],
  },
  {
    item: "Reports Menu",
    pathname: "/reports",
    permission: PAGE_PERMISSIONS.PERM_REPORTS_MENU,
    subMenus: [
      {
        item: "Monitoring",
        pathname: "/reports/monitoring",
        permission: PAGE_PERMISSIONS.PERM_MONITORING_REPORT,
      },
      {
        item: "AdHoc",
        pathname: "/reports/adhoc",
        permission: PAGE_PERMISSIONS.PERM_ADHOC_REPORT,
      },
      {
        item: "Summary",
        pathname: "/reports/summary",
        permission: PAGE_PERMISSIONS.PERM_SUMMARY_REPORT,
      },
      {
        item: "Feed Missing",
        pathname: "/reports/feedmissing",
        permission: PAGE_PERMISSIONS.PERM_FEED_MISSING_REPORT,
      },
    ],
  },
  {
    item: "Masters Menu",
    pathname: "/masters",
    permission: PAGE_PERMISSIONS.PERM_MASTERS_MENU,
    subMenus: [
      {
        item: "Brand",
        pathname: "/masters/brand",
        permission: PAGE_PERMISSIONS.PERM_BRAND_MASTER,
      },
      {
        item: "Channel",
        pathname: "/masters/channel",
        permission: PAGE_PERMISSIONS.PERM_CHANNEL_MASTER,
      },
      {
        item: "Content Langauge",
        pathname: "/masters/language",
        permission: PAGE_PERMISSIONS.PERM_CONTENT_LANGUAGE_MASTER,
      },
      {
        item: "Genre",
        pathname: "/masters/genre",
        permission: PAGE_PERMISSIONS.PERM_GENRE_MASTER,
      },
      {
        item: "Program",
        pathname: "/masters/program",
        permission: PAGE_PERMISSIONS.PERM_PROGRAM_MASTER,
      },
      {
        item: "Promo",
        pathname: "/masters/promo",
        permission: PAGE_PERMISSIONS.PERM_PROMO_MASTER,
      },
    ],
  },
  {
    item: "Account Managers",
    pathname: "/account-managers",
    permission: PAGE_PERMISSIONS.PERM_ACCOUNT_MANAGERS,
    subMenus: [],
  },
  {
    item: "User Management Menu",
    pathname: "/users",
    permission: PAGE_PERMISSIONS.PERM_USER_MANAGEMENT_MENU,
    subMenus: [],
  },
  {
    item: "Subscriptions Menu",
    pathname: "/subscriptions",
    permission: PAGE_PERMISSIONS.PERM_SUBSCRIPTION_MENU,
    subMenus: [
      {
        item: "Subscription Listing",
        pathname: "/subscriptions/listing",
        permission: PAGE_PERMISSIONS.PERM_SUBSCRIPTION_LISTING,
      },
      {
        item: "Create Subscription",
        pathname: "/subscriptions/new",
        permission: PAGE_PERMISSIONS.PERM_SUBSCRIPTION_CREATE,
      },
    ],
  },
  {
    item: "Query Support Menu",
    pathname: "/support",
    permission: PAGE_PERMISSIONS.PERM_QUERY_SUPPORT_MENU,
    subMenus: [],
  },
  {
    item: "Billing Menu",
    pathname: "/billing",
    permission: PAGE_PERMISSIONS.PERM_BILLING_MENU,
    subMenus: [
      {
        item: "Rate Card",
        pathname: "/billing/rate-card",
        permission: PAGE_PERMISSIONS.PERM_BILLING_RATE_CARD,
      },
      {
        item: "Billing Details",
        pathname: "/billing/listing",
        permission: PAGE_PERMISSIONS.PERM_BILLING_LISTING,
      },
    ],
  },
  {
    item: "Clients Menu",
    pathname: "/clients",
    permission: PAGE_PERMISSIONS.PERM_CLIENTS_MENU,
    subMenus: [
      {
        item: "Group Advertiser",
        pathname: "/clients/group-advertisers",
        permission: PAGE_PERMISSIONS.PERM_GROUP_ADVERTISER_MANAGE,
      },
      {
        item: "Groups",
        pathname: "/clients/groups",
        permission: PAGE_PERMISSIONS.PERM_GROUP_LISTING,
      },
      {
        item: "Clients",
        pathname: "/clients/all",
        permission: PAGE_PERMISSIONS.PERM_CLIENT_LISTING,
      },
      {
        item: "New Client",
        pathname: "/clients/new",
        permission: PAGE_PERMISSIONS.PERM_CREATE_CLIENT,
      },
      {
        item: "Client Renewal List",
        pathname: "/clients/renewList",
        permission: PAGE_PERMISSIONS.PERM_CLIENT_RE_LISTING,
      },
    ],
  },
  {
    item: "File Details Menu",
    pathname: "/file",
    permission: PAGE_PERMISSIONS.PERM_FILE_DETAILS_MENU,
    subMenus: [],
  },
  {
    item: "Notification",
    pathname: "/notification",
    permission: PAGE_PERMISSIONS.PERM_NOTIFICATIONS,
    subMenus: [],
  },
  {
    item: "Activity Tracker Menu",
    pathname: "/activity",
    permission: PAGE_PERMISSIONS.PERM_ACTIVITY_TRACKER_MENU,
    subMenus: [],
  },
  {
    item: "Query Executor Menu",
    pathname: "/queryex",
    permission: PAGE_PERMISSIONS.PERM_QUERY_EXECUTOR_MENU,
    subMenus: [],
  },
];
